import '../stylesheets/App.css';
import React, { useState, useEffect } from 'react';
import { apiCall } from '../helpers/apiCallConfiguration';

const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

function SituacionActual() {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingSaldo, setLoadingSaldo] = useState(false);

    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const [filtroActivo, setFiltroActivo] = useState(false);

    const fetchData = (desde, hasta) => {
        let url = process.env.REACT_APP_API_BASE_URL + '/reportes/situacion-actual';
        if (desde && hasta) url += `?fechaDesde=${desde}&fechaHasta=${hasta}`;

        if (!data) {
            setLoading(true);
        } else {
            setLoadingSaldo(true);
        }

        apiCall(url, (resp) => {
            setData(resp.data);
            setLoading(false);
            setLoadingSaldo(false);
        });
    };

    useEffect(() => {
        fetchData('', '');
    }, []);

    const handleFiltrar = () => {
        if (!fechaDesde || !fechaHasta) return;
        setFiltroActivo(true);
        fetchData(fechaDesde, fechaHasta);
    };

    const handleLimpiar = () => {
        setFechaDesde('');
        setFechaHasta('');
        setFiltroActivo(false);
        fetchData('', '');
    };

    const fmt = (n) => '$ ' + parseFloat(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

    if (loading) return <div className="container my-5 text-center">Cargando...</div>;
    if (!data) return <div className="container my-5 text-center text-danger">Error al cargar datos.</div>;

    const mesLabel = MESES[data.mesProximo.mes - 1] + ' ' + data.mesProximo.anio;

    return (
        <div className="container my-5">
            <h1 className="general-subtitle text-center my-4">Situación Actual</h1>

            <div className="row g-4">

                {/* Tabla 1: Cobros próximo mes */}
                <div className="col-12 col-md-6">
                    <div className="border rounded border-dark-blue p-4">
                        <h5 className="mb-3">Total a cobrar — {mesLabel}</h5>
                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th>Nivel</th>
                                    <th className="text-end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.cobrosProximoMes.map((n, i) => (
                                    <tr key={i}>
                                        <td>Nivel {n.descripcion}</td>
                                        <td className="text-end">{fmt(n.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="fw-bold">
                                    <td>Total</td>
                                    <td className="text-end">{fmt(data.totalCobros)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                {/* Tabla 2: Saldo en calle */}
                <div className="col-12 col-md-6">
                    <div className="border rounded border-dark-blue p-4">
                        <h5 className="mb-2">Saldo en calle</h5>

                        {/* Filtro por rango de fechas */}
                        <div className="d-flex flex-wrap gap-2 align-items-end mb-3">
                            <div>
                                <label className="form-label mb-1 small">Desde</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={fechaDesde}
                                    onChange={e => setFechaDesde(e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="form-label mb-1 small">Hasta</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={fechaHasta}
                                    onChange={e => setFechaHasta(e.target.value)}
                                />
                            </div>
                            <button
                                className="btn btn-sm btn-dark"
                                onClick={handleFiltrar}
                                disabled={!fechaDesde || !fechaHasta || loadingSaldo}
                            >
                                Filtrar
                            </button>
                            {filtroActivo && (
                                <button className="btn btn-sm btn-outline-secondary" onClick={handleLimpiar}>
                                    Limpiar
                                </button>
                            )}
                        </div>

                        {filtroActivo && (
                            <p className="text-muted small mb-2">
                                Cuotas con vencimiento entre {fechaDesde} y {fechaHasta}
                            </p>
                        )}

                        {loadingSaldo ? (
                            <div className="text-center py-3">Cargando...</div>
                        ) : (
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Nivel</th>
                                        <th className="text-end">Saldo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.saldoEnCalle.map((n, i) => (
                                        <tr key={i} className={n.incobrable ? 'text-danger' : ''}>
                                            <td>Nivel {n.descripcion}{n.incobrable ? ' (incobrable)' : ''}</td>
                                            <td className="text-end">{fmt(n.total)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr className="fw-bold">
                                        <td>Total</td>
                                        <td className="text-end">{fmt(data.totalSaldo)}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SituacionActual;
